import React, {Component} from 'react';
import {connect} from 'react-redux';
import Tooltip from 'components/atoms/tooltip';
import {formatString} from 'helpers/string-helper';
import {isKeyPlayerLineupPositionUsed} from 'components/organisms/projection-boost-rule/helpers';

class RuleItem extends Component {
    getStatementFor(item) {
        const {players} = this.props;

        let statementFor = '';
        if (item.isStatementTypePlayer() && item.getKeyPlayer()) {
            const player = players.getPlayer(item.getKeyPlayer());
            statementFor = `player ${player?.name ?? '?'}`;
        } else if (item.isStatementTypePosition() && item.getKeyPosition()) {
            statementFor = `position ${item.getKeyPosition()}`;
        }

        return statementFor;
    }
    getBoostFor(boostStatement) {
        const {players} = this.props;
        const statementTemplate = '{0} projection for {1} by {2}%';

        let boostFor = '';
        if (boostStatement.isBoostForPlayer()) {
            const player = players.getPlayer(boostStatement.getBoostedPlayer());
            boostFor = `player ${player.name}`;
        } else if (boostStatement.isBoostForPosition()) {
            boostFor = `positions ${boostStatement.getBoostedPositions().join(', ')} from `;
            boostFor += boostStatement.isSameTeam() ? 'same team' : 'opposing team';
        }

        return formatString(
            statementTemplate,
            boostStatement.getBoostType(),
            boostFor,
            boostStatement.getBoostPercent(),
        );
    }
    getRuleView() {
        const {projectionBoostRule, itemId, sportConfig} = this.props;
        const useKeyPlayerLineupPosition = isKeyPlayerLineupPositionUsed(sportConfig);
        const item = projectionBoostRule.getItem(itemId);
        const ruleTemplate = ['If {0} is ', 'in lineup then {1}'];

        const statementFor = this.getStatementFor(item);
        const boostStatementsContent = item
            .getBoostStatements()
            .map((boostStatement) => this.getBoostFor(boostStatement));

        const subject = [];
        const tooltipSubject = [];
        if (boostStatementsContent.length > 1) {
            tooltipSubject.push(formatString(ruleTemplate[0], statementFor));
            useKeyPlayerLineupPosition && tooltipSubject.push(`${item.getKeyPlayerLineupPosition()} `);
            tooltipSubject.push(formatString(ruleTemplate[1], boostStatementsContent.join(' and ')));

            subject.push(formatString(ruleTemplate[0], statementFor));
            useKeyPlayerLineupPosition && subject.push(`${item.getKeyPlayerLineupPosition()} `);
            subject.push(formatString(ruleTemplate[1], `${boostStatementsContent[0]} and ...`));
        } else {
            subject.push(formatString(ruleTemplate[0], statementFor));
            useKeyPlayerLineupPosition && subject.push(`${item.getKeyPlayerLineupPosition()} `);
            subject.push(formatString(ruleTemplate[1], boostStatementsContent.join(' and ')));
        }

        return (
            <>
                {subject.join('')}
                {tooltipSubject.length ? <Tooltip subject={tooltipSubject.join('')} /> : null}
            </>
        );
    }

    render() {
        const {children} = this.props;

        return (
            <span className="advanced-tag">
                {this.getRuleView()}
                {children}
            </span>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        projectionBoostRule,
        playersData: {players},
    } = state;

    return {
        sportConfig,
        projectionBoostRule,
        players,
    };
}

export default connect(mapStatesToProps)(RuleItem);
